export const W8_DOCUMENT_ENDPOINT =
  'app-pf/international-account/bff/global-account/v1/documents/w8'

export const W8_TERM_ID = 'w8-ben'

export const W8_TERM_TITLE = 'W8-BEN Form'
